module.exports = __webpack_public_path__ + "static/media/SH.48c68434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SH.svg
// module id = 357
// module chunks = 0